export const APP_URL = "https://www.gestaointeligentemv.com.br";

export const APP_PUBLIC_URL = APP_URL.replace(/\/$/, "");
export const PASSWORD_RESET_URL = `${APP_PUBLIC_URL}/reset-password`;
export const PASSWORD_RESET_CALLBACK_URL = `${APP_PUBLIC_URL}/auth/callback?next=${encodeURIComponent("/reset-password")}`;